import $apiCte from './api'

export default class CteService {
    static async listar(filtros) {
        return await $apiCte.get(`v1/conhecimentos`, {
            ...filtros
        });
    }

    static async visualizar(id) {
        return await $apiCte.get(`v1/conhecimentos/visualizar/${id}`);
    }

    static async buscarDadosAdicionar() {
        return await $apiCte.get('v1/conhecimentos/adicionar');
    }

    static async adicionar(payload) {
        return await $apiCte.post('v1/conhecimentos/adicionar', payload);
    }

    static async buscarDadosEditar(id) {
        return await $apiCte.get(`v1/conhecimentos/editar/${id}`);
    }

    static async editar(id, payload) {
        return await $apiCte.put(`v1/conhecimentos/editar/${id}`, payload);
    }

    static async remover(id) {
        return await $apiCte.delete(`v1/conhecimentos/excluir/${id}`);
    }

    static async verificaSeExiste(nct) {
        return await $apiCte.get(`v1/conhecimentos/verifica-se-existe/${nct}`);
    }
    
    static async transmitir(id) {
        return await $apiCte.get(`v1/conhecimentos/transmitir/${id}`);
    }

    static async baixarXml(id) {
        return await $apiCte.get(`v1/conhecimentos/baixar-xml/${id}`);
    }

    static async imprimirDacte(id) {
        return await $apiCte.getBlob(`v1/conhecimentos/imprimir-dacte/${id}`);
    }

    static async exportarXml(pagina, hash, filtros) {
        return await $apiCte.post(`v1/conhecimentos/exportar-xmls?page=${pagina}&hash=${hash}`, filtros);
    }

    static async exportarExcel(payload) {
        return await $apiCte.post(`v1/conhecimentos/exportar-xls`, { registros: payload });
    }

    static async importarXml(formData) {
        return await $apiCte.post(`v1/conhecimentos/importar-xml`, formData);
    }

    static async cancelarConhecimento(payload) {
        return await $apiCte.put(`v1/conhecimentos/cancelar/${payload.id}`, { motivo: payload.motivo });
    }
    
    static async buscaDadosRelatorioCte() {
        return await $apiCte.get(`v1/relatorio/cte`);
    }
  
    static async enviaEmail(payload) {
        return await $apiCte.post(`v1/conhecimentos/enviar-email`, payload);
    }

    static async gerarFinanceiro(payload) {
        return await $apiCte.post(`v1/conhecimentos/gerar-financeiro`, payload);
    }

    static async buscarXmlTransmitirA3(id) {
        return await $apiCte.get(`v1/conhecimentos/a3/buscar-xml-transmitir/${id}`, {},  false);
    }

    static async autorizarA3(payload) {
        return await $apiCte.post(`v1/conhecimentos/a3/autorizar`, payload, false);
    }

    static async buscarXmlCancelarA3(payload) {
        return await $apiCte.get(`v1/conhecimentos/a3/buscar-xml-cancelar/${payload.id}`, { motivo: payload.motivo },  false);
    }

    static async cancelarA3(payload) {
        return await $apiCte.post(`v1/conhecimentos/a3/cancelar`, payload,  false);
    }
}